import script from "./MarcasXProductoView.vue?vue&type=script&setup=true&lang=js"
export * from "./MarcasXProductoView.vue?vue&type=script&setup=true&lang=js"

import "./MarcasXProductoView.vue?vue&type=style&index=0&id=33391a60&lang=css"

const __exports__ = script;

export default __exports__